// @ts-nocheck
import { getFastenersTableApiParameter } from "@store/Framework/Store/Store/Components/FastenersTable/FastenersTableSelector";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useFastenersTableApiParameter = convertSelectorToHook(getFastenersTableApiParameter);
